import { ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import flatpickr from 'flatpickr';
import { IpemarksService } from '../ipemarks.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ipe-dialog',
  templateUrl: './ipe-dialog.component.html',
  styleUrls: ['./ipe-dialog.component.scss']
})
export class IpeDialogComponent {
  IPEMARKSForm!: FormGroup;
  @ViewChild('dateInput', { static: false }) dateInput!: ElementRef;
  inputdate: any;
  monthWiseDetails: any[] = [];
  testlist: any[] = [];
  filteredTestList: any[] = [];
  listofsection: any[] = [];
  filteredSectionList: any[] = [];
  buildinglist: any[] = [];
  filteredBuildingList: any[] = [];

  selectedTestCode: any;
  selectedSectionId: any;
  selectedtestname = '';
  selectedBuildingName = '';
  selectedSectionName = '';

  testQuery = '';
  buildingQuery = '';
  sectionQuery = '';

  stream: any;
  group: any;
  class: any;
  program: any;
  testname1: any;
  buildingid: any;
  classid: any;
  subjectlist: Object;
  testWiseSubjects: any;
  testForm: FormGroup;
  subjectsState: { [key: string]: boolean } = {};
  section: any;
  Section: any;
  private flatpickrInstance: any;
  private datePickerRetries = 0;

  constructor(
    private fb: FormBuilder,
    private services: IpemarksService,
    private dialogRef: MatDialogRef<IpeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.IPEMARKSForm = this.fb.group({
      inputdate: ['', Validators.required],
      testCode: ['', Validators.required],
      Building: ['', Validators.required],
      Section: ['', Validators.required]
    });

    this.IPEMARKSForm.patchValue({
      inputdate: this.data.date,
      testCode: this.data.testname,
      Building: this.data.buliding,
      Section: this.data.section,
    });

    if (this.data.checkbox) {
      this.subjectsState = { ...this.data.checkbox };
    }

    if (this.data.date) {
      this.inputdate = this.data.date;
      this.buildingid = this.data.buliding;
      this.selectedTestCode = this.data.testname;
      this.selectedSectionId = this.data.section;
      this.classid = this.data.classid;

      this.services.gettestlist(this.inputdate).subscribe((res: any) => {
        this.testlist = res.testNames || [];
        this.filteredTestList = [...this.testlist];
        this.onbuildinglist();
        const selectedTest = this.testlist.find((test: any) => test.testCode == this.selectedTestCode);
        if (selectedTest) {
          this.selectedtestname = selectedTest.testName;
          this.classid = selectedTest.classId;
        }
      });

      if (this.buildingid && this.classid) {
        this.services.getsectionlist(this.buildingid, this.getIpeLocationParams()).subscribe((res: any) => {
          this.listofsection = Array.isArray(res) ? res : [];
          this.filteredSectionList = [...this.listofsection];
          this.onsubject();
          const selectedSection = this.listofsection.find(
            (section: any) => section.sectionId == this.selectedSectionId
          );
          if (selectedSection) {
            this.class = selectedSection.displayName;
            this.group = selectedSection.groupName;
            this.stream = selectedSection.streamName;
            this.program = selectedSection.programName;
            this.section = selectedSection.sectionName;
            this.Section = selectedSection.sectionName;
            this.selectedSectionName = selectedSection.sectionName;
          }
        });
      }
    }

    this.datmethod();
  }

  datmethod() {
    this.services.getdatelist().subscribe((res: any) => {
      this.monthWiseDetails = res.mothWiseDetails;
      this.initializeDatePicker();
    });
  }

  initializeDatePicker() {
    if (!this.dateInput?.nativeElement) {
      if (this.datePickerRetries < 20) {
        this.datePickerRetries++;
        setTimeout(() => this.initializeDatePicker(), 50);
      }
      return;
    }
    this.datePickerRetries = 0;
    if (!(this.monthWiseDetails && this.monthWiseDetails.length > 0)) {
      return;
    }

    const allowedDates = this.monthWiseDetails.map((item: any) => {
      const [day, month, year] = item.ipeMarks.testStartDate.split('-');
      return new Date(+year, +month - 1, +day);
    });

    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
    }

    this.flatpickrInstance = flatpickr(this.dateInput.nativeElement, {
      dateFormat: 'd-m-Y',
      enable: allowedDates,
      allowInput: false,
      clickOpens: true,
      closeOnSelect: true,
      disableMobile: true,
      defaultDate: this.inputdate || this.IPEMARKSForm?.value?.inputdate || undefined,
      appendTo: document.body,
      onReady: (_selectedDates, _dateStr, instance) => {
        instance.calendarContainer.classList.add('ipe-flatpickr');
      },
      onChange: (_selectedDates, dateStr) => {
        this.IPEMARKSForm.patchValue({ inputdate: dateStr });
        this.onDateSelected(dateStr);
        // Close after date is chosen
        setTimeout(() => this.flatpickrInstance?.close(), 0);
        this.cdr.detectChanges();
      },
    });
  }

  openCalendar(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    if (this.flatpickrInstance) {
      this.flatpickrInstance.open();
    } else {
      this.initializeDatePicker();
      setTimeout(() => this.flatpickrInstance?.open(), 50);
    }
  }

  onDateSelected(dateStr: string) {
    this.inputdate = dateStr;
    if (!this.inputdate) {
      return;
    }
    this.buildingid = null;
    this.selectedBuildingName = '';
    this.listofsection = [];
    this.filteredSectionList = [];
    this.selectedSectionId = '';
    this.selectedSectionName = '';
    this.selectedTestCode = '';
    this.selectedtestname = '';
    this.subjectsState = {};
    this.testWiseSubjects = [];
    this.testQuery = '';
    this.buildingQuery = '';
    this.sectionQuery = '';
    this.IPEMARKSForm.patchValue({ testCode: '', Building: '', Section: '' });

    this.services.gettestlist(this.inputdate).subscribe((res: any) => {
      this.testlist = res.testNames || [];
      this.filteredTestList = [...this.testlist];
    });
  }

  testname(e: any) {
    this.onDateSelected(e?.target?.value);
  }

  filterTests(): void {
    const q = (this.testQuery || '').toLowerCase();
    this.filteredTestList = (this.testlist || []).filter((t: any) =>
      (t.testName || '').toLowerCase().includes(q)
    );
  }

  filterBuildings(): void {
    const q = (this.buildingQuery || '').toLowerCase();
    this.filteredBuildingList = (this.buildinglist || []).filter((b: any) =>
      (b.buildingName || '').toLowerCase().includes(q)
    );
  }

  filterSections(): void {
    const q = (this.sectionQuery || '').toLowerCase();
    this.filteredSectionList = (this.listofsection || []).filter((s: any) =>
      (s.sectionName || '').toLowerCase().includes(q)
    );
  }

  selectTest(test: any): void {
    this.selectedTestCode = test.testCode;
    this.selectedtestname = test.testName;
    this.classid = test.classId;
    this.listofsection = [];
    this.filteredSectionList = [];
    this.selectedSectionId = '';
    this.selectedSectionName = '';
    this.buildingid = null;
    this.selectedBuildingName = '';
    this.subjectsState = {};
    this.testWiseSubjects = [];
    this.section = '';
    this.IPEMARKSForm.patchValue({
      testCode: test.testCode,
      Building: '',
      Section: ''
    });
    this.onbuildinglist();
  }

  selectBuilding(b: any): void {
    this.buildingid = b.buildingId;
    this.selectedBuildingName = b.buildingName;
    this.selectedSectionId = '';
    this.selectedSectionName = '';
    this.listofsection = [];
    this.filteredSectionList = [];
    this.IPEMARKSForm.patchValue({ Building: b.buildingId, Section: '' });

    if (!this.buildingid || !this.classid) {
      return;
    }
    this.services.getsectionlist(this.buildingid, this.getIpeLocationParams()).subscribe((res: any) => {
      this.listofsection = Array.isArray(res) ? res : [];
      this.filteredSectionList = [...this.listofsection];
    });
  }

  selectSection(s: any): void {
    this.selectedSectionId = s.sectionId;
    this.selectedSectionName = s.sectionName;
    this.class = s.displayName;
    this.group = s.groupName;
    this.stream = s.streamName;
    this.program = s.programName;
    this.section = s.sectionName;
    this.Section = s.sectionName;
    this.IPEMARKSForm.patchValue({ Section: s.sectionId });
    this.onsubject();
  }

  studentmarkslist() {
    if (!this.inputdate) {
      alert('Please select Exam Date');
    } else if (!this.selectedTestCode) {
      alert('Please select Test Name');
    } else if (!this.buildingid) {
      alert('Please select Building');
    } else if (!this.selectedSectionId) {
      alert('Please select Section');
    } else {
      this.closeNav();
    }
  }

  closeNav() {
    const data = {
      selectedTestCode: this.selectedTestCode,
      selectedSectionId: this.selectedSectionId,
      testdate: this.inputdate,
      testname1: this.selectedtestname,
      building: this.buildingid,
      classid: this.classid,
      class: this.class,
      stream: this.stream,
      group: this.group,
      program: this.program,
      section: this.section,
      subject: this.subjectsState
    };
    this.dialogRef.close(data);
  }

  onbuildinglist() {
    this.services.getipebuilding(this.getIpeLocationParams()).subscribe((res: any) => {
      this.buildinglist = Array.isArray(res) ? res : [];
      this.filteredBuildingList = [...this.buildinglist];
      if (this.buildingid) {
        const selected = this.buildinglist.find((b: any) => b.buildingId == this.buildingid);
        this.selectedBuildingName = selected?.buildingName || '';
      }
    });
  }

  private getIpeLocationParams(): {
    academicId?: any;
    classId?: any;
    groupId?: any;
    streamId?: any;
    programId?: any;
  } {
    return {
      academicId: this.data?.academicId ?? this.data?.academicYearId,
      classId: this.data?.classId ?? this.classid,
      groupId: this.data?.groupId,
      streamId: this.data?.streamId,
      programId: this.data?.programId
    };
  }

  close() {
    this.dialogRef.close();
  }

  onCheckboxChange(subject: string, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.subjectsState = { ...this.subjectsState, [subject]: isChecked };
    this.cdr.detectChanges();
  }

  onsubject() {
    if (!this.selectedTestCode || !this.inputdate) {
      return;
    }
    this.services.checksubject(this.selectedTestCode, this.inputdate).subscribe({
      next: (response: any) => {
        this.testWiseSubjects = response.headers.testWiseSubjects;
        this.testWiseSubjects.forEach((subject: any) => {
          this.subjectsState[subject.subject] = this.subjectsState[subject.subject] ?? false;
        });
      },
      error: (err: any) => {
        console.error('Error fetching subjects:', err);
      },
    });
  }
}
